export default __webpack_public_path__ + "static/media/heading-settings-new.3439a912.png";